export default "__VITE_ASSET__Cqi_XJjj__"